import auth from './auth';

export default function withCompanyName(title) {
  if (auth.company?.name) {
    return `${title} · ${auth.unescapedCompanyName}`;
  }

  return title;
}
